/* eslint-disable @typescript-eslint/no-explicit-any */
import { RouteComponentProps } from 'react-router-dom';

import { ActionsType, StoreType } from '@tock/shared/utils/connect';
import { core, safeToNumber } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';

import { Button } from 'omakase';
import ButtonGroup from '@tock/shared/components/buttons/ButtonGroup';
import ConsumerPanel from 'components/ConsumerPanel';
import Receipt from 'components/account/transfer/Receipt';
import SectionHeader from 'components/SectionHeader';
import uiFlowComponent, { FlowProps } from 'components/ui-flow/uiFlowComponent';

export interface Props extends RouteComponentProps {
  actions: ActionsType;
  onInitiateTransfer(arg: any): Promise<any>;
  transfer: StoreType['transfer'];
}

class TransferConfirmRoute extends BaseComponent<Props & FlowProps> {
  handleContinue() {
    this.props.history.replace(`/profile/reservations/${this.props.transfer.purchase.id}`);
  }

  handleTransfer() {
    return this.props
      .onInitiateTransfer({
        purchaseId: this.props.transfer.purchase.id,
        transferTo: {
          email: this.props.transfer.transferToEmail,
        },
        discount:
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          this.props.transfer.purchase.amountPaidCents! - this.props.transfer.transferPrice!,
      })
      .then(this.handleContinue)
      .catch((response) => {
        // If TRANSFER_NOT_ALLOWED_AT_THIS_TIME, don't override the toast message.
        if (
          !response ||
          !response.error ||
          safeToNumber(response.error.errorCode) !== 4028 ||
          safeToNumber(response.error.errorCode) !== 2002
        ) {
          this.props.actions.toast.showError('Unable to start transfer');
        }
      });
  }

  render() {
    const { transfer } = this.props;

    return (
      <div className="MainContent">
        <div className="SectionWrapper">
          <div className="SectionContent">
            <SectionHeader
              heading="Review transfer"
              subheading="For security purposes we require you to confirm this transfer via email. Click the button below to receive the email, and click on the link inside the email to initiate the transfer."
            />

            <ConsumerPanel heading="Transfer Details">
              <Receipt
                purchase={transfer.purchase as core.PastPurchase}
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                transferToEmail={transfer.transferToEmail!}
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                transferPrice={transfer.transferPrice!}
              />
            </ConsumerPanel>

            <ConsumerPanel>
              <ButtonGroup>
                <Button
                  fullWidth
                  disabled={transfer.requestInProgress}
                  variant="primary"
                  size="large"
                  onClick={this.handleTransfer}
                >
                  Send Confirmation Email
                </Button>
              </ButtonGroup>
            </ConsumerPanel>
          </div>
        </div>
      </div>
    );
  }
}

export default uiFlowComponent(TransferConfirmRoute);
